<template>
  <div class="index-page">
    <div class="header">
      <kd-tab-bar type="text" :value="tab" :items-data="tabItems" @change="switchTab" />
      <div class="my-address" @click="navToMyAddress">管理地址></div>
    </div>
    <div class="main">
      <order-list-comp v-if="tab === 'order'"></order-list-comp>
      <course-list-comp v-if="tab === 'course'"></course-list-comp>
      <red-env-list-comp v-if="tab === 'redenv'"></red-env-list-comp>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component } from 'kuaidong-component'
import { KdTabBar, KdTabItem } from 'kuaidong-ui'
import CourseListComp from '@/views/my-gift/components/CourseList.vue'
import OrderListComp from '@/views/my-gift/components/OrderList.vue'
import RedEnvListComp from '@/views/my-gift/components/RedEnvList.vue'
enum OrderType {
  Course = 'course',
  Order = 'order',
  RedEnv = 'redenv',
}
@Component({
  components: { KdTabBar, KdTabItem, CourseListComp, OrderListComp, RedEnvListComp },
})
export default class IndexPage extends BasePage {
  get tabItem() {
    return this.tabItems.find((item) => item.name === this.tab) || this.tabItems[0]
  }

  tab = OrderType.RedEnv
  tabItems = [
    {
      name: OrderType.RedEnv,
      label: '微信红包',
    },
    {
      name: OrderType.Order,
      label: '礼品订单',
    },
    {
      name: OrderType.Course,
      label: '课程订单',
    },
  ]

  mounted() {
    const params = this.$route.query
    if (params.selectTab === OrderType.Order) {
      this.tab = OrderType.Order
    }
  }

  switchTab(tab: OrderType) {
    this.tab = tab
  }

  navToMyAddress() {
    this.$router.push({
      name: 'my_gift_address',
    })
  }
}
</script>
<style lang="less">
.index-page {
  box-sizing: border-box;
  > .header {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    > .label {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #4d4d4d;
    }

    > .my-address {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #8f8f8f;
    }

    > .kd-tab-bar__type--text {
      > .kd-tab-bar__tab-items {
        > .kd-tab-item__type--text::before {
          width: 0;
        }

        > .kd-tab-item--active {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: #4d4d4d;
        }

        > .kd-tab-item--inactive {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: #4d4d4d;
          opacity: 0.6;
        }
      }
    }
  }

  > .main {
    padding: 0 16px;

    > .pe-empty-comp {
      margin-top: 133px;
    }
  }
}
</style>
